import { render, staticRenderFns } from "./GridOverview.vue?vue&type=template&id=474fa684&"
import script from "./GridOverview.vue?vue&type=script&lang=js&"
export * from "./GridOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports